import React, { Suspense } from "react";
//import { HashRouter as  BrowserRouter, Routes, Route } from 'react-router-dom';
import { HashRouter as BrowserRouter, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import esES from "antd/es/locale/es_ES";
import frFR from "antd/es/locale/fr_FR";
import { AuthProvider } from "./contexts";
import { AdminRouter } from "./router/AdminRouter";
import { useLocaleStore } from "./store/localeStore";

// Ant Design trae sus propios textos (paginacion, calendarios, "Sin datos",
// filtros de tabla). Sin esto, la interfaz saldria traducida pero los
// componentes de la libreria seguirian en espanol, que es el resultado a medias
// mas visible que hay.
const localesAntd = {
  es: esES,
  fr: frFR,
};

export default function App() {
  const locale = useLocaleStore((s) => s.locale);

  return (
    <ConfigProvider locale={localesAntd[locale] ?? esES}>
      <AuthProvider>
        {/* Aplicamos los flags aquí, sobre el componente que actúa como Router */}
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          {/*
            Suspense cubre la carga de los ficheros de traduccion, que van por
            HTTP y bajo demanda. Sin el, la primera pantalla de cada namespace
            reventaria en vez de esperar.
          */}
          <Suspense fallback={null}>
            <Routes>
              {/* Rutas principales del sitio web */}
              <Route path="/*" element={<AdminRouter />} />
              {/* Rutas del administrador */}
              <Route path="/portal/*" element={<AdminRouter />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  );
}
